<template>
  <div class="pagefoot">
    {{$t('shopping.all_rights_reserved')}} {{blogname}}
    <!-- <a href="/pages/return-policy">Refund policy</a>
    <a href="/pages/privacy-policy">Privacy policy</a>
    <a href="/pages/terms-of-service">Terms of service</a>-->
  </div>
</template>
<script>
export default {
  props:['blogname']
};
</script>
<style scoped lang='scss'>
.pagefoot {
  margin-top: 50px;
  border-top: 1px solid #e6e6e6;
  padding: 14px 0;
  font-size: 12px;
  color: #737373;
  a {
    font-size: 12px;
    color: #128fae;
    text-decoration: none;
  }

  & > a:not(:last-child) {
    margin-right: 20px;
  }
}
</style>